import ajaxService from './ajaxService';

export default {
  // 新增QRCODE行銷活動未完成事項
  createQRCodeMessageClick(body) {
    return ajaxService.post('/rmu/post/api/v1/richMenu/clickedRecord', body);
  },
};
